import React, { useState } from 'react';
import ExcalmationSvg from './ExcalmationSvg';
import VIconSvg from './VIconSvg';

interface Props {
  themeEnabled: boolean;
  activateTheme: () => void;
}

const ThemeStatusMessage: React.FC<Props> = ({ themeEnabled, activateTheme }) => {
  const [hasActivatedTheme, setHasActivatedTheme] = useState(false);

  const onActivateClick = () => {
    activateTheme();
    setHasActivatedTheme(true);
  };

  if (hasActivatedTheme) {
    return (
      <div className="reactions-theme-status-message-container">
        <VIconSvg />
        <span className="reactions-theme-status-message-text">This theme is now enabled</span>
      </div>
    );
  }

  if (!themeEnabled) {
    return (
      <div className="reactions-theme-status-message-container">
        <ExcalmationSvg fill="#ff6f00" />
        <span className="reactions-theme-status-message-text">
          {"This theme is turned off (you can edit it but it won't be displayed)."}
        </span>
        <button className="btn-link" onClick={onActivateClick}>
          turn on
        </button>
      </div>
    );
  }
  return null;
};

export default ThemeStatusMessage;
